import { gql } from '@graphql/__generated__';

export const BROCHURE_REPORT_INCLUDE_FRAGMENT = gql(/* GraphQL */ `
  fragment BrochureReportInclude on lots {
    brochure_include_cover
    brochure_include_property
    brochure_include_description
    brochure_include_photos
    brochure_include_pois
    brochure_include_poi_map
    brochure_poi_map_zoom_level
    brochure_include_append_files
  }
`);

export const GET_BROCHURE_REPORT = gql(/* GraphQL */ `
  query GetBrochureReport($id: uuid!) {
    lots_by_pk(id: $id) {
      id
      updated_at
      broker_id
      broker {
        id
        active_teams_users: teams_users(
          where: { deactivated: { _eq: false } }
        ) {
          team_id
          team {
            id
            lots_member_access
          }
        }
      }
      show_image_captions_on_brochure
      doc_template {
        id
        content
        filename_template
        translations
      }
      doc_template_theme_id
      doc_template_theme {
        id
        name
        content
      }
      property {
        id
        updated_at
        ...StepPois
      }
      ...StepCoverPhotoBrochure
      ...StepDescriptionBrochure
      ...StepPropertyDetailsBrochure
      ...BrochureReportInclude
      __typename
    }
  }
`);

export const STEP_COVER_PHOTO_BROCHURE_FRAGMENT = gql(/* GraphQL */ `
  fragment StepCoverPhotoBrochure on lots {
    id
    title
    updated_at
    use_custom_brochure_title
    brochure_title_en
    brochure_title_fr
    brochure_title_de
    brochure_title_it
    brochure_title_pl
    brochure_title_pt
    brochure_title_es
    hide_price_on_brochure
    address_display_option_brochure
    brochure_show_agent_on_brochure
    brochure_font_family
    doc_template {
      id
    }
    doc_template_theme_id
    doc_template_theme {
      id
      name
    }
    brochure_cover_image_id
    brochure_cover_image {
      id
    }
    broker {
      id
      language
      default_team {
        id
        branding_color
      }
    }
    property {
      id
      property_images(
        where: { display_on_brochure: { _eq: true } }
        order_by: { order_nr: asc }
      ) {
        ...ReportPropertyImage
      }
    }
  }
`);

export const UPDATE_BROCHURE_COVER = gql(/* GraphQL */ `
  mutation UpdateBrochureCover($id: uuid!, $input: lots_set_input!) {
    update_lots_by_pk(pk_columns: { id: $id }, _set: $input) {
      ...StepCoverPhotoBrochure
    }
  }
`);

export const STEP_DESCRIPTION_BROCHURE_FRAGMENT = gql(/* GraphQL */ `
  fragment StepDescriptionBrochure on lots {
    id
    updated_at
    brochure_description_en
    brochure_description_fr
    brochure_description_de
    brochure_description_it
    brochure_description_pl
    brochure_description_pt
    brochure_description_es
    use_custom_brochure_description
    brochure_description_layout
    description
    broker {
      id
      language
    }
  }
`);
export const UPDATE_BROCHURE_DESCRIPTION = gql(/* GraphQL */ `
  mutation UpdateBrochureDescription($id: uuid!, $input: lots_set_input!) {
    update_lots_by_pk(pk_columns: { id: $id }, _set: $input) {
      ...StepDescriptionBrochure
    }
  }
`);

export const UPDATE_PROPERTY_DETAILS_BROCHURE = gql(/* GraphQL */ `
  mutation UpdatePropertyDetailsBrochure($id: uuid!, $input: lots_set_input!) {
    update_lots_by_pk(pk_columns: { id: $id }, _set: $input) {
      id
      ...StepPropertyDetailsBrochure
    }
  }
`);

export const UPDATE_STEP_POI_BROCHURE = gql(/* GraphQL */ `
  mutation UpdateStepPOIBrochure($id: uuid!, $input: lots_set_input!) {
    update_lots_by_pk(pk_columns: { id: $id }, _set: $input) {
      id
      updated_at
    }
  }
`);

export const STEP_PROPERTY_DETAILS_BROCHURE_FRAGMENT = gql(/* GraphQL */ `
  fragment StepPropertyDetailsBrochure on lots {
    id
    updated_at
    sale_price
    rent_net
    rent_extra
    offer_type
    status
    currency
    available_from
    lot_reference
    price_unit
    is_parking_included_in_total
    parking_price
    parking_price_type
    indoor_parking_price
    outdoor_parking_price
    property {
      id
      updated_at
      balcony_surface
      basement_surface
      building_condition
      building_standard
      building_volume
      built_surface
      charges
      commercial_potential_rental_income
      commercial_surface
      commercial_yearly_rental_income
      construction_year
      consumption
      cooling
      distance_to_airport
      distance_to_city_center
      distance_to_grocery_shop
      distance_to_high_school
      distance_to_hospital
      distance_to_kindergarten
      distance_to_motorway
      distance_to_primary_school
      distance_to_public_transport
      distance_to_sports_center
      distance_to_train_station
      emissions
      energy_certificate_version
      energy_consumption_class
      energy_inspection_date
      energy_reference_year
      estimated_higher_energy_cost
      estimated_lower_energy_cost
      floor_of_flat
      garden_surface
      gas_emissions_class
      gross_floor_surface
      has_attic
      has_cellar
      has_elevator
      has_fireplace
      has_gym
      has_photovoltaic_panels
      has_sauna
      has_storage_room
      has_swimming_pool
      has_view
      has_wellness_area
      heating
      heating_distribution
      income_includes_parking
      is_child_friendly
      is_commercial_fully_rented
      is_luxury
      is_maisonette
      is_new_development
      is_parking_fully_rented
      is_rental
      is_residential_fully_rented
      is_secondary_residence
      is_wheelchair_accessible
      land_surface
      living_surface
      macro_location
      micro_location
      minergie_code
      number_of_bathrooms
      number_of_bedrooms
      number_of_commercial_units
      number_of_floors
      number_of_indoor_parkings
      number_of_outdoor_parkings
      number_of_residential_units
      number_of_rooms
      number_of_toilets
      orientation
      is_oriented_north
      is_oriented_south
      is_oriented_east
      is_oriented_west
      parking_potential_rental_income
      parking_yearly_rental_income
      plot_number
      renovation_fund
      renovation_year
      residential_potential_rental_income
      residential_surface
      residential_yearly_rental_income
      side
      terrace_surface
      usable_surface
      weighted_floor_surface
    }
  }
`);

export const STEP_PHOTOS_BROCHURE_FRAGMENT = gql(/* GraphQL */ `
  fragment StepPhotosBrochure on lots {
    id
    updated_at
    show_image_captions_on_brochure
    property {
      id
      updated_at
      property_images(
        where: { display_on_brochure: { _eq: true } }
        order_by: { order_nr: asc }
      ) {
        ...ReportPropertyImage
      }
    }
  }
`);

export const UPDATE_STEP_PHOTOS_BROCHURE = gql(/* GraphQL */ `
  mutation UpdateStepPhotosBrochure($id: uuid!, $input: lots_set_input!) {
    update_lots_by_pk(pk_columns: { id: $id }, _set: $input) {
      ...StepPhotosBrochure
    }
  }
`);

export const DOC_TEMPLATES_BROCHURE_REPORT = gql(/* GraphQL */ `
  query DocTemplatesBrochureReport {
    doc_templates(
      where: { type: { _eq: lot_brochure }, active: { _eq: true } }
    ) {
      id
      name
      active
      type
      translations
    }
  }
`);

export const UPDATE_BROCHURE_REPORT_FILE = gql(/* GraphQL */ `
  mutation UpdateBrochureReportFile($id: uuid!, $input: lots_set_input!) {
    update_lots_by_pk(pk_columns: { id: $id }, _set: $input) {
      id
      updated_at
    }
  }
`);

export const UPDATE_TEAM_BRANDING_COLOR_BROCHURE = gql(/* GraphQL */ `
  mutation UpdateTeamBrandingColorBrochure(
    $teamId: uuid!
    $brandingColor: String
    $reportId: uuid!
  ) {
    update_teams_by_pk(
      pk_columns: { id: $teamId }
      _set: { branding_color: $brandingColor }
    ) {
      id
      branding_color
    }
    update_lots_by_pk(
      pk_columns: { id: $reportId }
      _set: { updated_at: "now()" }
    ) {
      id
      updated_at
    }
  }
`);
